<div class="container">
  @if (title) {
    <h2 class="mat-headline-6" mat-dialog-title>{{ title }}</h2>
  }

  @if (message) {
    <mat-dialog-content
      class="mat-body markdown"
      [innerHtml]="message | markdown | async"
    >
    </mat-dialog-content>
  }

  <mat-dialog-actions>
    @if (acceptButtonText && !reverseButtonOrder) {
      @if (acceptUrl) {
        <a
          [href]="acceptUrl"
          [mat-dialog-close]="true"
          mat-flat-button
          class="celo-primary-button uppercase"
          >{{ acceptButtonText }}</a
        >
      } @else {
        <button
          (click)="handleAccept()"
          [disabled]="isLoading$ | async"
          mat-button
          class="celo-primary-button uppercase"
        >
          @if (isLoading$ | async) {
            <app-basic-spinner [diameter]="20"></app-basic-spinner>
          }
          @if ((isLoading$ | async) === false) {
            {{ acceptButtonText }}
          }
        </button>
      }
    }

    @if (!acceptOnly) {
      <button
        [mat-dialog-close]="false"
        [disabled]="isLoading$ | async"
        mat-button
        class="celo-secondary-button uppercase"
      >
        {{ closeButtonText }}
      </button>
    }

    @if (acceptButtonText && reverseButtonOrder) {
      @if (acceptUrl) {
        <a
          [href]="acceptUrl"
          [mat-dialog-close]="true"
          mat-flat-button
          class="celo-primary-button uppercase"
          >{{ acceptButtonText }}</a
        >
      } @else {
        <button
          (click)="handleAccept()"
          [disabled]="isLoading$ | async"
          mat-button
          class="celo-primary-button uppercase"
        >
          @if (isLoading$ | async) {
            <app-basic-spinner [diameter]="20"></app-basic-spinner>
          }
          @if ((isLoading$ | async) === false) {
            {{ acceptButtonText }}
          }
        </button>
      }
    }
  </mat-dialog-actions>
</div>
